<template>
  <div id="taskPagId" onselectstart="return false">
    <div class="circle" id="circle" style="overflow:auto">
      <!-- @row-dblclick="rowDbclick" -->
      <!--<draggable v-model="taskSource" tag="el-table__row">-->
      <el-table
        @row-click="openDetails"
        border
        ref="taskTable"
        @row-dblclick="rowDbclick"
        v-loading="loading"
        element-loading-text="加载中,请稍候"
        element-loading-spinner="el-icon-loading"
        :data="taskSource"
        tooltip-effect="dark"
        style="width: 100%;"
        :height="tableHeight"
        v-scrollBar:tableArg
        highlight-current-row
        :header-cell-style="{'font-family':'MicrosoftYaHei','font-weight':'bold','font-size':'16px','padding': '5px 0','background':'#f8f6f6','color':'#333333','letter-spacing': '0.6px'}"
        :cell-style="{'font-family':'MicrosoftYaHei','font-size':'16px','padding': '5px 0','color':'#4f5869'}"
        v-loadmore="load"
        @current-change="handleCurrentChange"
        @selection-change="handleSelectionChange"
        @row-contextmenu="rowContextmenu"
        @select="select"
        @select-all="selectAll"
      >
        <el-table-column type="selection" width="30" v-if="isCheckbox"></el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="TASKSTATENAME" align="center" width="40">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.TASKSTATENAME" placement="top">
              <div :class="scope.row.STATE|taskStateFormater"></div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column sortable label="创建人" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span href="#" v-html="Highlight(scope.row,'创建人',scope.row.CREATEUSERNAME)"></span>
          </template>
        </el-table-column>
        <el-table-column sortable label="任务名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-popover
              v-show="isPopover(scope.row)"
              placement="top-start"
              width="400"
              trigger="hover"
            >
              <div>
                <el-row v-for="(item,index) in scope.row.MatchFields" :key="index">
                  <el-col :span="5">{{ item.Name+':' }}</el-col>
                  <el-col :span="19" v-html="item.Value"></el-col>
                </el-row>
              </div>
              <div slot="reference" @click="taskSelected(scope.row)" style="cursor:pointer">
                <div
                  class="taskName"
                  v-html="Highlight(scope.row,'任务名',getTaskShowName(scope.row))"
                ></div>
                <div
                  class="taskContent"
                  v-html="Highlight(scope.row,'任务详情',delHtmlTag(scope.row.CONTENT))"
                ></div>
              </div>
            </el-popover>
            <div
              v-show="!isPopover(scope.row)"
              @click="taskSelected(scope.row)"
              style="cursor:pointer"
            >
              <div class="taskName" v-html="Highlight(scope.row,'任务名',getTaskShowName(scope.row))"></div>
              <div
                class="taskContent"
                v-html="Highlight(scope.row,'任务详情',delHtmlTag(scope.row.CONTENT))"
              ></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable prop="CREATETIME" label="创建时间" width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.CREATETIME|timeFormater }}</template>
        </el-table-column>
        <el-table-column
          sortable
          prop="SERVERCENTERNAME"
          label="服务台"
          width="120"
          show-overflow-tooltip
        >
          <!-- <template slot-scope="scope">
            <i class="iconfont icon-diannao1"></i>
          </template>-->
        </el-table-column>
        <el-table-column label="执行人" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span href="#" v-html="Highlight(scope.row,'执行人',scope.row.EXCUTEUSERNAME)"></span>
          </template>
        </el-table-column>

        <el-table-column prop="FOCUSDEGREE" align="center" label="关注度" width="100">
          <template slot-scope="scope">
            <!-- <div :class="scope.row.FOCUSDEGREE|focusDegreeFormater">
            </div>-->
            <el-rate v-model="scope.row.FOCUSDEGREE" @change="grade" :max="3"></el-rate>
          </template>
        </el-table-column>
        <p v-if="noMore">没有更多了</p>
      </el-table>
      <!--</draggable>-->
    </div>
    <contextMenu ref="contextMenu" :contextMenu="contextMenu"></contextMenu>

    <TaskDetails ref="taskDetail"></TaskDetails>
  </div>
</template>

<script>
import { getTaskByTaskId } from "@/api/modules/basicData/task.js";
import { mapState } from "vuex";
import {
  GetNoticeInstance,
  GetNoticeResult,
  AddTemplate,
  UpdateTemplate,
  GetTaskListByTaskIdList,
  AddConstGroupTask,
} from "@/api/modules/basicData/task";

import Sortable from "sortablejs";
import draggable from "vuedraggable";
import TaskDetails from "./TaskDetails.vue";
import contextMenu from "@/views/task/common/contextmenu.vue";
export default {
  components: {
    TaskDetails,
    draggable,
    contextMenu,
  },
  name: "TaskList",
  props: {
    contextMenuData: {
      type: Object,
      require: true,
    },
    tableHeight: {
      type: [Number, String],
      default: function () {
        return $(window).height() - 200;
      },
    },
  },
  data() {
    return {
      templateName: "",
      innerVisible: false,
      tubiaoClass: "",
      dragDiv: false,
      dragDiv2: false,
      items: [],
      taskIdDown: [],
      multipleSelection: [],
      fightServerCenters: [], //当前人员可抢单的服务台
      curUserOnlineServerCenters: [], //当前人已经登陆的服务台
      tags: [],
      endX: 0,
      endY: 0,
      tubiaoId: "",
      bom: true,
      bqName: "",
      nowLocationX: 0,
      nowLocationY: 0,
      selectionArr: [], //全选中的数组
      value: null,
      num: null,
      newRow: {}, // 当前任务
      contextMenu: {},
      // contextMenuData: {
      // 	menuName: 'taskList',
      // 	axis: {
      // 		x: null,
      // 		y: null
      // 	},
      // 	data: null,
      // 	menulists: this.$store.state.task.taskcontextMemu,
      // },
      consttask: {
        TASKID: "",
        USERID: "",
        GROUPID: "",
        FOCUSDEGREE: "",
      },
    };
  },
  computed: {
    loading: function () {
      return this.$store.state.task.loading;
    },
    taskSource: function () {
      return this.$store.state.task.taskSource;
    },
    // 			icons: function() {
    // 				return this.$store.state.task.icons;
    // 			},
    templateTag: function () {
      return this.$store.state.task.templateTag;
    },
    // 			tagItem: function() {
    // 				return this.$store.state.task.tagItem;
    // 			},
    tagLength: function () {
      return this.$store.state.task.tagLength;
    },
    isDragArea: function () {
      return this.$store.state.task.isDragArea;
    },
    userId: function () {
      return this.$store.state.task.userId;
    },
    isCheckbox: function () {
      return this.$store.state.task.isCheckbox;
    },
    allTemplate: function () {
      return this.$store.state.task.allTemplate;
    },
    resultList: function () {
      return this.$store.state.resultBase.resultList;
    },
    isExpand: function () {
      return this.$store.state.task.isExpand;
    },
    totalCount: function () {
      return this.$store.state.task.totalCount;
    },
    isInfiniteScroll() {
      return this.$store.state.task.isInfiniteScroll;
    },
    noMore() {
      let taskData = this.$store.state.task.taskSource;
      taskData = taskData ? taskData : [];
      return taskData.length >= this.totalCount;
    },
    // disabled () {
    //    return this.loading || this.noMore
    // }
  },
  provide() {
    return {
      say: this.say,
    };
  },
  mounted() {
    // this.$store.dispatch("getAllTemplate").then((res) => {});
    this.rowDrop();
  },
  watch: {
    // 这里的定时器是为了优化，如果频繁调用window.onresize方法会造成页面卡顿，增加定时器会避免频繁调用window.onresize方法timer默认值设置为false，这里相当于一个按钮，防止频繁改变时引起卡顿
    listHeight(val) {
      if (!this.timer) {
        this.listHeight = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
    // 			bqName(val) {
    // 				this.$store.state.task.templateTag = [];
    // 				val.forEach(c => {
    // 					this.templateTag.push(c);
    // 				});
    // 			},
    // 			tagItem(val){
    // 				console.log(val,"当前选中的模板");
    // 				if (val.TEMPTYPE == 0) {
    // 					let content = JSON.parse(val.CONTENT)
    // 					console.log(content);
    // 					this.$store.state.task.searchCondition = content.queryTitle;
    // 					this.$store.dispatch("changeTaskParas", searchJs.searchTask(content, true));
    // 				} else if (val.TEMPTYPE == 1) {
    // 					this.$store.state.task.resultTagItem = val;
    // 					GetTaskListByTaskIdList(val.CONTENT, this.userId).then(res => {
    // 						console.log(res, "结果集模板搜索")
    // 						this.$store.state.task.taskSource = res;
    // 						if (res.length > 0) {
    // 							this.$store.commit('setResult', res);
    // 							this.$store.state.resultBase.isResult = true;//判断当前是否点击结果集
    // 						}
    // 					})
    // 				}
    // 			}
  },
  methods: {
    getTaskShowName(row) {
      console.log("getTaskShowName", row);
      let name = "";
      if (!row.CONTENT) {
        name = row.TASKNAME;
      } else {
        name = scope.row.TASKNAME + "-";
      }
      if (row.TagList.length > 0) {
        let tagNames = row.TagList.map(
          (tag) =>
            ` <span style="background:${tag.COLOR}" class="taskListTag-span">${tag.TAGNAME}</span>`
        ).join("");
        name = tagNames + name;
      }
      return name;
    },
    deleteResult(data) {
      if (data) {
        data.forEach((row) => {
          this.$refs.taskTable.toggleRowSelection(row, false);
        });
      } else {
        this.$refs.taskTable.clearSelection();
      }
    },
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        sort: false,
        //   onEnd({ newIndex, oldIndex }) {
        //     const currRow = _this.taskSource.splice(oldIndex, 1)[0]
        //     _this.taskSource.splice(newIndex, 0, currRow)
        //   }
        onStart: function ({ newIndex, oldIndex }) {
          const currRow = _this.taskSource[oldIndex]; //.splice(oldIndex, 1)[0];
          _this.$store.commit("draggableRow", currRow);
        },
      });
    },
    load() {
      if (
        this.isInfiniteScroll &&
        this.$store.state.task.taskSource.length < this.totalCount &&
        this.loading == false
      ) {
        this.$store.state.task.pageIndex = this.$store.state.task.pageIndex + 1;
        this.$store.dispatch("changeScrollPageIndex", {
          index: this.$store.state.task.pageIndex,
          type: this.$store.state.task.type,
        });
      }
    },
    clearSelection() {
      this.$refs.taskTable.clearSelection();
    },
    grade(val) {
      let taskIndex = this.taskSource.indexOf(this.newRow);
      console.log(taskIndex, "taskIndex");
      if (this.num !== val) {
        this.num = val;
      } else {
        this.num--;
        this.$store.state.task.taskSource[taskIndex].FOCUSDEGREE = this.num;
      }

      console.log(this.num);
      setTimeout(() => {
        console.log(this.newRow, "this.newRow");
        this.consttask.GROUPID = "";
        this.consttask.TASKID = this.newRow.ID;
        this.consttask.FOCUSDEGREE = this.num;
        this.consttask.ISUSER = true;
        this.consttask.USERID = this.$store.state.task.userId;
        AddConstGroupTask(this.consttask).then((res) => {
          console.log(res);
        });
      }, 500);
    },
    getBqName() {
      console.log("调用");
    },
    searchTb() {
      this.innerVisible = false;
      this.tubiaoClass = this.tubiaoId;
    },
    tubiao(val, index) {
      this.tubiaoId = val;
      // icon-renwu3
    },
    openDetails(row, column, event) {
      console.log("点击事件");
      this.newRow = row;
      this.$store.state.task.taskRow = row;
      if (this.isExpand) {
        // 判断是否点开右侧
        this.$store.state.task.taskRow = row;
        this.$refs.taskTable.toggleRowSelection(row);
        let aaa = this.multipleSelection.indexOf(row);
        if (aaa > -1) {
          this.$store.commit("addResult", {
            row: row,
            bol: true,
          });
        } else {
          this.$store.commit("addResult", {
            row: row,
            bol: false,
          });
        }
      }
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
    },
    handleSelectionChange(val) {
      // console.log(val, "选择");
      this.multipleSelection = val;
      // this.$store.state.task.pendingTaskList = val;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.taskTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.taskTable.clearSelection();
      }
    },
    handleCurrentChange(row, oldRow) {
      if (row) {
        console.log("单击--row", row);
        this.$store.commit("changeCurTask", row);
        this.$parent.changeCurTask(row);
      }
    },
    rowDbclick(row, event) {
      //双击行事件
      // if (row) {
      //   this.$store.commit("changeCurTask", row);
      //   this.$emit('changeCurTask',row);
      // }
      // this.$refs.taskDetail.openDialog(row);
      this.openBlank(row.ID);
    },
    openBlank(taskid) {
      let routeUrl = this.$router.resolve({
        path: "/task-detailspage",
        query: { taskid: taskid },
      });
      window.open(routeUrl.href, "_blank");
    },
    taskSelected(row) {
      // this.$refs.taskDetail.openDialog(row);
    },
    getRowKey(row) {
      console.log(row.ID);
      return row.ID;
    },
    rowContextmenu(row, column, event) {
      // console.log('右击')
      this.contextMenu = row;
      event.preventDefault();
      // this.$emit("rowContextmenu", {
      //   x: event.clientX,
      //   y: event.clientY,
      //   data: row
      // });

      const postition = {
        top: event.clientY,
        left: event.clientX,
      };
      console.log("postition", postition);
      this.$refs.contextMenu.Show(postition);
    },
    Highlight(row, title, FieldValue) {
      //高亮显示
      if (row.MatchFields) {
        let fieldRow = row.MatchFields.filter((p) => p.Name === title);
        if (fieldRow.length > 0)
          // alert(row.MatchFields.filter(p => p.Name === 'TASKNAME').Value)
          return fieldRow[0].Value;
        else return FieldValue;
      } else {
        return FieldValue;
      }
    },
    isPopover(row) {
      if (row.MatchFields) {
        if (row.MatchFields.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    select(selection, row) {
      //勾选事件
      // 				console.log("勾选", row);
      // 				console.log("勾选--selection", selection);
      // 				console.log("勾选--------resultList", this.$store.state.resultBase.resultList)
      let aaa = selection.indexOf(row);
      if (aaa > -1) {
        this.$store.commit("addResult", {
          row: row,
          bol: true,
        });
      } else {
        this.$store.commit("addResult", {
          row: row,
          bol: false,
        });
      }
    },
    selectAll(selection) {
      //全选事件
      // console.log("勾选--------resultList", this.resultList);

      // let resultList = this.$store.state.resultBase.resultList;
      if (selection.length > 0) {
        this.selectionArr = Object.assign({}, selection);
        console.log(this.selectionArr, "this.selectionArr---------1");
        selection.forEach((c) => {
          this.$store.commit("addResult", {
            row: c,
            bol: true,
          });
        });
      } else {
        console.log(this.selectionArr, "this.selectionArr");
        Object.keys(this.selectionArr).forEach((key) => {
          // console.log(key, this.selectionArr[key]);
          this.$store.commit("addResult", {
            row: this.selectionArr[key],
            bol: false,
          });
        });
      }

      // console.log("全选", selection);
    },
    Follow(row) {},
    // taskNameContent(row) {
    // 	if (row.MatchFields) {
    // 		let fieldRow = row.MatchFields.filter(p => p.Name === 'TASKNAME');
    // 		let NameContent = '';
    // 		if (fieldRow.length > 0)
    // 			// alert(row.MatchFields.filter(p => p.Name === 'TASKNAME').Value)
    // 			NameContent = fieldRow[0].Value;
    // 		else
    // 			NameContent = row.TASKNAME;
    // 		let CONTENT = row.MatchFields.filter(p => p.Name === 'CONTENT');
    // 		let NameContent = '';
    // 		if (CONTENT.length > 0)
    // 			// alert(row.MatchFields.filter(p => p.Name === 'TASKNAME').Value)
    // 			NameContent +="-"+ CONTENT[0].Value;
    // 		else
    // 			NameContent = row.CONTENT;
    // 	} else {
    // 		return FieldValue;
    // 	}
    // },
  },
  filters: {
    createSourceFormater: function (val) {
      switch (val) {
        case 0:
          return "PC桌面";
        case 1:
          return "微信";
        case 2:
          return "电话";
        case 3:
          return "网站";
        case 8:
          return "统一桌面";
        case 5:
          return "邮件";
        case 6:
          return "监控";
        case 7:
          return "运维APP";
        default:
          return "";
      }
    },
    taskDegreeFormater: function (val) {
      switch (val) {
        case 0:
          return "重要且紧急";
        case 1:
          return "重要不紧急";
        case 2:
          return "紧急不重要";
        case 3:
          return "不重要不紧急";
        default:
          return "";
      }
    },
    focusDegreeFormater: function (val) {
      switch (val) {
        case 1:
          return "一级关注";
        case 2:
          return "二级关注";
        case 3:
          return "三级关注";
        default:
          return "";
      }
    },
    taskStateFormater: function (val) {
      switch (val) {
        case 0:
          return "daijieshou";
        case 1:
          return "zhixingzhong";
        case 2:
          return "wancheng";
        case 3:
          return "guanbi";
        case 4:
          return "shenpizhong";
        case 5:
          return "guaqizhong";
        case -1:
          return "zuofei";
        default:
          return "guanbi";
      }
    },
  },
};
</script>

<style scoped>
.tasktype {
  margin-right: 10px !important;
}
.circle >>> .el-scrollbar__wrap {
  /*overflow-x: auto;*/
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 16px; /*滚动条宽度*/
  height: 16px; /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: red; /*滚动条的背景颜色*/
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: green; /*滚动条的背景颜色*/
}
a {
  color: #409eff;
  text-decoration: none;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.biaoti {
  text-align: left;
  color: #409eff;
  font-size: 16px;
  font-weight: bold;
  height: 22px;
  border-left: 2px solid #409eff;
  line-height: 22px;
  padding-left: 10px;
}

.biaoqian {
  height: 50px;
}

.tuozhuai {
  position: absolute;
  z-index: 9999;
}

/*el-table{*/
/*height: 100%;*/
/*}*/
.taskName {
  font-weight: bold;
  float: left;
}

.taskContent {
  float: left;
  color: #929baa;
}

/* .el-table--enable-row-hover .el-table__body tr:hover {
										background: #d5dae6;
										border: 1px solid #313463;
										box-shadow: 0 0 1px 1px #313463, inset 0 0 10px 5px rgba(49, 52, 99, 0.20);
									} */
.el-table tbody tr:hover > td {
  background-color: #d5dae6;
}

.daiding {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/daiding.png);
}

.daijieshou {
  text-align: center;
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/daijieshou.png);
}

.shenpizhong {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/shenpizhong.png);
}

.wancheng {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/wancheng.png);
}

.zhixingzhong {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/zhixingzhong.png);
}

.zuofei {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/zuofei.png);
}

.guanbi {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/guanbi.png);
}

.guanzhu1 {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/关注.png);
}

.guanzhu2 {
  width: 36px;
  height: 18px;
  background: url(../../../../src/assets/img/关注.png);
}

.guanzhu3 {
  width: 54px;
  height: 18px;
  background: url(../../../../src/assets/img/关注.png);
}

.noguanzhu {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/未关注.png);
}
</style>
